/**
 * Create store system ipv6 routing-radvd
 *
 * @since 2018-07-24
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // config
    radvdConfig: `${smApiPrefix}/ipv6/radvd/config`,
    // interfaces list
    radvdInterfaces: `${smApiPrefix}/ipv6/radvd/config/interfaces`,
    // interface candidates
    radvdIfsCandis: `${smApiPrefix}/ipv6/radvd/config/interface-candidates`,
    // rip apply
    radvdApply: `${smApiPrefix}/ipv6/radvd/config/apply`,
    // rip cancel
    radvdCancel: `${smApiPrefix}/ipv6/radvd/config/cancel`
  },
  // copyData of editing.
  selectedItem: {},
  // rip config
  radvdConfig: {
    enable: 0 //      required (one of 0, 1)
  },
  // clone of radvdConfig
  radvdConfigClone: {
    enable: 0 //      required (one of 0, 1)
  },
  radvdInterfaces: {
    id: 0,
    ifc_id: '',
    ifc_name: '',
    dist_default_gw: 0, // (OFF: 0, ON: 1)
    prefix: []
  },
  radvdPrefixInfo: {
    id: 0,
    addr: null,
    mask: 64
  },
  radvdInterfacesList: [],
  // prefix candidates of interface
  radvdIfsCandidateList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  resetRadvdConfig (state) {
    state.radvdConfig.enable = 0
  },
  setRadvdConfig (state, data) {
    if (data !== undefined) {
      state.radvdConfig.enable = data.enable
      // clone
      state.radvdConfigClone.enable = _.cloneDeep(data.enable)
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip network
  // network dialog
  clearRadvdInterfaceDialog (state) {
    state.radvdInterfaces.id = 0
    state.radvdInterfaces.ifc_id = ''
    state.radvdInterfaces.ifc_name = ''
    state.radvdInterfaces.dist_default_gw = 0
    state.radvdInterfaces.prefix = []
  },
  setRadvdInterfaceDialog (state, item) {
    state.radvdInterfaces.id = item.id
    state.radvdInterfaces.ifc_id = item.ifc_id
    state.radvdInterfaces.ifc_name = item.ifc_name
    state.radvdInterfaces.dist_default_gw = item.dist_default_gw
    if (item.prefix !== undefined) {
      for (const pFix of item.prefix) {
        pFix.id = `${_.random(100, 10000)}_${pFix.addr}`
      }
      state.radvdInterfaces.prefix = item.prefix
    } else {
      state.radvdInterfaces.prefix = []
    }
  },
  resetRadvdInterfaceList (state) {
    state.radvdInterfacesList = []
  },
  setRadvdInterfaceList (state, data) {
    if (data !== undefined) {
      state.radvdInterfacesList = data
    }
  },
  addRadvdInterfaceList (state, item) {
    if (item !== undefined) {
      state.radvdInterfacesList.push(item)
    }
  },
  editRadvdInterfaceList (state, item) {
    const findRslt = _.find(state.radvdInterfacesList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.radvdInterfacesList.splice(_.findIndex(state.radvdInterfacesList, state.selectedItem), 1, item)
    }
  },
  delRadvdInterfaceList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.radvdInterfacesList.splice(item.itemIndex, 1)
      }
    }
  },
  resetRadvdInterfaceCandidates (state) {
    state.radvdIfsCandidateList = []
  },
  setRadvdInterfaceCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ifs of data) {
        state.radvdIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  // radvd prefix dialog
  clearRadvdPrefixDialog (state) {
    state.radvdPrefixInfo.id = ''
    state.radvdPrefixInfo.addr = null
    state.radvdPrefixInfo.mask = 8
  },
  setRadvdPrefixDialog (state, item) {
    state.radvdPrefixInfo.id = item.id
    state.radvdPrefixInfo.addr = item.addr
    state.radvdPrefixInfo.mask = item.mask
  },
  // prefix CRUD
  resetRadvdPrefixList (state) {
    state.radvdInterfaces.prefix = []
  },
  setRadvdPrefixList (state, data) {
    if (data !== undefined) {
      state.radvdInterfaces.prefix = data
    }
  },
  addRadvdPrefixList (state, item) {
    state.radvdInterfaces.prefix.push(item)
  },
  editRadvdPrefixList (state, item) {
    const findRslt = _.find(state.radvdInterfaces.prefix, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.radvdInterfaces.prefix.splice(_.findIndex(state.radvdInterfaces.prefix, state.selectedItem.item), 1, item)
    }
  },
  delRadvdPrefixList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.radvdInterfaces.prefix.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip config
  async getRadvdConfig ({commit, state}, loadingOpt) {
    commit('resetRadvdConfig')
    const apiUrl = state.apiUrlPath['radvdConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRadvdConfig', result)
      return true
    } else {
      return false
    }
  },
  async editRadvdConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['radvdConfig']
    const rslt = await this.$axios.$put(apiUrl, state.radvdConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setRadvdConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< radvd config
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> radvd interface
  async getRadvdInterfaceList ({commit, state}, loadingOpt) {
    commit('resetRadvdInterfaceList')
    const apiUrl = state.apiUrlPath['radvdInterfaces']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRadvdInterfaceList', result)
      return true
    } else {
      return false
    }
  },
  // prefix for radvd-interface
  async getRadvdIfsCandidateList ({commit, state}) {
    commit('resetRadvdInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['radvdIfsCandis'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRadvdInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  // add , // edit , // del(multi)
  async addRadvdInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['radvdInterfaces']
    const addParam = _.cloneDeep(state.radvdInterfaces)
    delete addParam.id
    // delete GUI id & itemIndex
    for (const pFix of addParam.prefix) {
      delete pFix.id
      delete pFix.itemIndex
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addRadvdInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editRadvdInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['radvdInterfaces']
    const putParam = _.cloneDeep(state.radvdInterfaces)
    // delete GUI id & itemIndex
    for (const pFix of putParam.prefix) {
      delete pFix.id
      delete pFix.itemIndex
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.radvdInterfaces.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editRadvdInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delRadvdInterfaceList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['radvdInterfaces']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delRadvdInterfaceList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  addRadvdPrefixList ({commit, state}) {
    const addParam = _.cloneDeep(state.radvdPrefixInfo)
    // make id
    addParam.id = `${_.random(100, 10000)}_${addParam.addr}`
    addParam.mask = Number(addParam.mask)
    commit('addRadvdPrefixList', addParam)
    return true
  },
  editRadvdPrefixList ({commit, state}) {
    const putParam = _.cloneDeep(state.radvdPrefixInfo)
    putParam.mask = Number(putParam.mask)
    commit('editRadvdPrefixList', putParam)
    return true
  },
  delRadvdPrefixList ({commit, state}, param) {
    commit('delRadvdPrefixList', param.itemIndexList)
    return true
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip network
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip apply & cancel
  async setRadvdApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['radvdApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setRadvdCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['radvdCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip apply & cancel
}

export const getters = {
  // rip Config
  compareRadvdConfigData (state) {
    return compareObject(state.radvdConfig, state.radvdConfigClone)
  }
}

export const strict = false
